export interface industryData {
    industryName: string,
    classification: string,
    mainCategory: string,
    subCategory: string,
    item: string,
    itemFlg: string,
    scaleCode: string,
    searchScaleCode: string,
    selectedL: string,
    selectedM: string,
    selectedS: string,
    selectedF: string,
    selectedSearch: string,
    selectedRadio: string,
    text: string,
}

export const industryDataInit: industryData = {
    industryName: "",
    classification: "",
    mainCategory: "",
    subCategory: "",
    item: "",
    itemFlg: "",
    scaleCode: "",
    searchScaleCode: "",
    selectedL: "",
    selectedM: "",
    selectedS: "",
    selectedF: "",
    selectedSearch: "",
    selectedRadio: "option1",
    text: "",
}
